module.exports = {
      id: "price-usage",
      viewBox: "0 0 38 38",
      url: __webpack_public_path__ + "sprite-b16b2d73f82c96a320ba0490c6416430.svg#price",
      toString: function () {
        return this.url;
      }
    }